import { ApolloError } from '@apollo/client'

export const ExceptionCategories = {
  AUTHORIZATION: 'graphql-authorization',
  AUTHENTICATION: 'graphql-authentication',
  NO_SUCH_ENTITY: 'graphql-no-such-entity',
  ALREADY_EXISTS: 'graphql-already-exists',
  INPUT: 'graphql-input',
} as const

const categories = [
  'graphql-authorization',
  'graphql-authentication',
  'graphql-no-such-entity',
  'graphql-already-exists',
  'graphql-input',
] as const

type CategoryType = (typeof categories)[number]

export function getMagentoErrorCategory(error: unknown) {
  if (!(error instanceof ApolloError)) {
    return false
  }

  const category = error.graphQLErrors[0]?.extensions?.category

  if (typeof category !== 'string') {
    return false
  }

  return categories.includes(category as CategoryType)
    ? (category as CategoryType)
    : false
}
